import {Units} from '@mintdata/mint-kit/api/models/Units';

export class Position
{
    public constructor(public left:Units,
                       public top:Units)
    {
    }

    public toString():string
    {
        return this.left && this.top ? `${this.left} ${this.top}` : null;
    }

    public static fromPixels(left:number,
                             top:number):Position
    {
        return new Position(
            Units.fromPixels(left),
            Units.fromPixels(top),
        );
    }

    public static fromPercentages(left:number,
                                  top:number):Position
    {
        return new Position(
            Units.fromPercentages(left),
            Units.fromPercentages(top),
        );
    }
}
